module.exports = __webpack_public_path__ + "img/product_vidaza_pic.b699fdd7.png";